var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-button',{attrs:{"type":_vm.BUTTON_TYPES.SECONDARY},on:{"click":_vm.openWatchlistPage}},[_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.WATCHLIST}}),_vm._v(" Watchlist ("+_vm._s(_vm.watchlistSize)+") ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }